<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="filters" class="search-suggestions">
    <div
      v-for="filter in filters.theme"
      :key="filter.id || filter.label"
      class="pill pill--small suggestion"
      @click="searchQueryUpdate(filter.id ? String(filter.id) : filter.label, 'theme')"
    >
      <div class="pill-text">{{ filter.label.replace('~', ',') }}</div>
    </div>
    <div
      class="pill pill--small suggestion"
      @click="searchQueryUpdate('', 'all')"
    >
      <div class="pill-text">{{ $t('all_filters') }}</div>
    </div>
  </div>
</template>

<script>
/**
 * Filter suggestions with themes and districs
 * @example [none]
 */
export default {
  props: {
    filters: {
      type: Object,
    },
  },
  methods: {
    /**
     * Update page to seach and add query params of element clicked
     * @public This is a public method
     * @param {Number} value Item clickked to add
     * @param {String} type type of suggestion pressed (thesaurus/district)
     */
    searchQueryUpdate(value, type) {
      if (type === 'all') this.$router.push({ name: 'Search' })
      else this.$router.push({ name: 'Search', query: { [type]: value } })
    },
  },
}
</script>


<style lang="stylus" scoped>
.search-suggestions
  display: flex
  flex-wrap: wrap
  justify-content: center
  align-items: center
  gap: vw(10px) vw(6px)

  .mobile &
    flex-wrap: nowrap
    justify-content: flex-start
    overflow-y: auto

  .suggestion
    border-color: $lighter-blue
    background-color: $corpotative-color-very-light
    color: $corporate_color

    &:hover
      border-color: $corporate_color

    &:active
      background-color: $corporate_color
      color: #fff
</style>